import { c as _c } from "react/compiler-runtime";
import { Button, Separator, HStack, VStack, Field } from '@chakra-ui/react';
import { HelpModal } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/HelpModal';
import { PitchBuidlerFormProps } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder/FormSections/index';
import { RichMarkdownInput } from '@src/components/sco/RichMarkdownInput';
import { TextareaListField } from '@src/components/sco/TextareaListField';
import React, { useEffect } from 'react';
export const OptionsSection: React.FC<PitchBuidlerFormProps> = props => {
  const $ = _c(33);
  const [showHelpModal, setShowHelpModal] = React.useState(false);
  const [emailTemplateSignature, setEmailTemplateSignature] = React.useState(props.investorSearch.emailTemplateSignature || "");
  const [emailTemplatePrompt, setEmailTemplatePrompt] = React.useState(props.investorSearch.emailTemplatePrompt || "");
  let t0;
  if ($[0] !== emailTemplatePrompt || $[1] !== emailTemplateSignature || $[2] !== props) {
    t0 = async t1 => {
      const next = t1 === undefined ? _temp : t1;
      if (!props.investorSearch.investorSearchId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertInvestorSearch({
        variables: {
          input: {
            investorSearchId: props.investorSearch.investorSearchId,
            emailTemplateSignature,
            emailTemplatePrompt
          }
        }
      });
      if (next) {
        next();
      }
    };
    $[0] = emailTemplatePrompt;
    $[1] = emailTemplateSignature;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const performSave = t0;
  let t1;
  if ($[4] !== emailTemplatePrompt || $[5] !== props.investorSearch.emailTemplatePrompt) {
    t1 = () => {
      if (props.investorSearch.emailTemplatePrompt !== emailTemplatePrompt) {
        setEmailTemplatePrompt(props.investorSearch.emailTemplatePrompt);
      }
    };
    $[4] = emailTemplatePrompt;
    $[5] = props.investorSearch.emailTemplatePrompt;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== props.investorSearch.emailTemplatePrompt) {
    t2 = [props.investorSearch.emailTemplatePrompt];
    $[7] = props.investorSearch.emailTemplatePrompt;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Field.Label>Signature Block</Field.Label>;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      bgColor: "containerAlpha.500"
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== performSave) {
    t5 = () => performSave();
    $[11] = performSave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = values => setEmailTemplateSignature(values.markdown);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== emailTemplateSignature || $[15] !== t5) {
    t7 = <Field.Root>{t3}<RichMarkdownInput boxProps={t4} initialMarkdownValue={emailTemplateSignature} onBlur={t5} onChange={t6} /></Field.Root>;
    $[14] = emailTemplateSignature;
    $[15] = t5;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Field.Label>Additional Instructions</Field.Label>;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      placeholder: "Modify phrasing, tone, and more",
      size: "sm"
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== emailTemplatePrompt) {
    t10 = <Field.Root>{t8}<TextareaListField itemLabel="Instruction" value={emailTemplatePrompt} textareaProps={t9} onChange={setEmailTemplatePrompt} /></Field.Root>;
    $[19] = emailTemplatePrompt;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== performSave) {
    t11 = <HStack justify="flex-end" padding={2} width="full"><Button size="xs" variant="cta" onClick={() => performSave()}>Save</Button></HStack>;
    $[21] = performSave;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t7) {
    t12 = <VStack align="stretch" gap={6} padding={4}>{t7}{t10}{t11}</VStack>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t7;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator marginX={4} />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== showHelpModal) {
    t14 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[28] = showHelpModal;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t12 || $[31] !== t14) {
    t15 = <>{t12}{t13}{t14}</>;
    $[30] = t12;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};
function _temp() {}